(function ($, window) {
  let $tabMediaFilters = $('.mcl-services-filters');
  if ($tabMediaFilters.length > 0) {

  }
})
(jQuery, window);
